import Vue from 'vue'
import Vuex from 'vuex'

import app from './modules/app'
import user from './modules/user'

// default router permission control
import permission from './modules/permission'

// dynamic router permission control (Experimental)
// import permission from './modules/async-router'
import getters from './getters'
import design from './modules/design'
import myGallery from './modules/myGallery'
import gruopDesign from './modules/gruopDesign'
import mergeSKU from './modules/mergeSKU'
import orderList from './modules/orderList'
import threeLoader from './modules/threeLoader'
Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    user,
    permission,
    design,
    myGallery,
    gruopDesign,
    mergeSKU,
    orderList,
    threeLoader
  },
  state: {},
  mutations: {},
  actions: {},
  getters
})
